import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Pagination from '../../page/Pagination';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import FILING_CONTROLLER from '../../../controllers/filing';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
import ReactComponentHelper from "../../helper/ReactComponentHelper";
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';
const log = new Logger('EC_LISTING_FILING_VALUES', LOG_LEVELS.DEBUG);

class EcListingLineDetails extends Component {

    render() {
        log.debug('render(): ');
        const ecListingDetails = (this.props.ecListingDetails && this.props.ecListingDetails.lines) || [];
        const totalAmount = this.props.ecListingDetails && this.props.ecListingDetails.totalAmount;
        const ecListingDetailsCols = [ 
            { 
                Header: (<span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'ecListingDetails_InvoiceNr')}</span>),
                accessor: "invoiceNumber"
            },
            {
                Header: (<span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'ecListingDetails_InvoiceDate')}</span>),
                accessor: "invoiceDate",
                Footer: (
                    <div style={{width: '100%', textAlign: 'right'}} className={withFullStoryExclude()}>
                        <strong>{LANGUAGES_CONTROLLER.format(this.props.languages, 'ecListingDetails_Total')}</strong>:
                    </div>
                )
            },
            {
                Header: (<span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'ecListingDetails_Amount')}</span>),
                accessor: "amount",
                ...ReactComponentHelper.getCurrencyColumnOptions({ isSensitive: true }),
                filterable: false,
                Footer: (
                    <span className={withFullStoryExclude("text-align-right")}>
                         {
                            parseFloat((totalAmount * 100) / 100).toFixed(2)
                        } 
                    </span>
                )
            },
            { 
                Header: (<span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'ecListingDetails_SupplierInvoiceNr')}</span>),
                accessor: "supplierInvoiceNumber"
            }
        ];

        return (
            <div>
                <ReactTable
                   data={ecListingDetails}
                   columns={ecListingDetailsCols} 
                   minRows={0}
                   maxRows={0}
                   loading={this.props.loading}
                   defaultPageSize={10}
                   pageSizeOptions={[5,10,20, 25, 50, 100]}
                   showPagination={ecListingDetails.length > 10} 
                   showPageJump={false}
                   PaginationComponent={Pagination}
                   noDataText={LANGUAGES_CONTROLLER.format(this.props.languages, 'ecListingFilingValues_NoData')}
                   style={{maxHeight: "625px"}} className="-striped -highlight"/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const props = {
        languages: state.languages,
        ecListingDetails: (state.filing && state.filing.ecListingDetails) || []
    }
    log.debug('mapStateToProps(): ', props);
    return props;

}

function mapDispatchersToProps(dispatch) {
    return {
        onShowEcListingDetails: (params) => {
            log.debug('onShowEcListingDetails: ', params);
            dispatch(FILING_CONTROLLER.doLoadEcListingDetails(params));
          }
    };
}


export default connect(mapStateToProps, mapDispatchersToProps)(EcListingLineDetails);